// @flow

import React from 'react';
import type { FuelInfo } from '../../types';
import {
  Key,
  Value,
  Row,
  List,
  Title,
  Container,
} from './atoms';
import Tooltip from '../tooltip';

type Specification = {
  key: string,
  value: string | number,
  info?: ?FuelInfo,
};

type Props = {|
  title: string,
  specifications: Array<Specification>,
|};

export default ({ title, specifications }: Props) => (
  <Container>
    <Title>{title}</Title>
    <List>
      {specifications && specifications.map(({ key, value, info }) => (
        <Row key={key}>
          <Key>
            {key}
            {info && info.content !== '' && <Tooltip
              iconSize="1rem"
              {...info}
            />}
          </Key>
          <Value>{value}</Value>
        </Row>
      ))}
    </List>
  </Container>
);
